import styled from 'styled-components';

import { colors, cssBreakpoints, spacing } from 'theme/theme';

const SEARCH_FILTERS_DROPDOWN_CHIP_WIDTH = {
  en: '165px',
  es: '165px',
  pt: '180px',
};

export const SearchFiltersHolder = styled.form<{ $locale: UserLocale }>`
  z-index: 1;
  background: ${colors.white};
  border: 1px solid ${colors.selectionGrey};
  padding: ${spacing[16]} ${spacing[24]};

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    overflow: scroll;

    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    .search-filters-body > :last-child {
      display: none;
    }
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    .search-filters-body > :nth-child(n + 4):not(:last-child) {
      display: none;
    }
  }

  @media all and (min-width: calc(${cssBreakpoints.mdUp} + ${(props) =>
      SEARCH_FILTERS_DROPDOWN_CHIP_WIDTH[props.$locale]})) {
    .search-filters-body > :nth-child(4):not(:last-child) {
      display: initial;
    }
  }

  @media all and (min-width: calc(${cssBreakpoints.mdUp} + ${(props) =>
      SEARCH_FILTERS_DROPDOWN_CHIP_WIDTH[props.$locale]} * 2)) {
    .search-filters-body > :nth-child(5):not(:last-child) {
      display: initial;
    }
  }

  @media all and (min-width: calc(${cssBreakpoints.mdUp} + ${(props) =>
      SEARCH_FILTERS_DROPDOWN_CHIP_WIDTH[props.$locale]} * 3)) {
    .search-filters-body > :nth-child(6):not(:last-child) {
      display: initial;
    }
  }

  @media all and (min-width: calc(${cssBreakpoints.mdUp} + ${(props) =>
      SEARCH_FILTERS_DROPDOWN_CHIP_WIDTH[props.$locale]} * 4)) {
    .search-filters-body > :nth-child(7):not(:last-child) {
      display: initial;
    }
  }

  @media all and (min-width: calc(${cssBreakpoints.mdUp} + ${(props) =>
      SEARCH_FILTERS_DROPDOWN_CHIP_WIDTH[props.$locale]} * 5)) {
    .search-filters-body > :nth-child(8):not(:last-child) {
      display: initial;
    }
  }

  @media all and (min-width: calc(${cssBreakpoints.mdUp} + ${(props) =>
      SEARCH_FILTERS_DROPDOWN_CHIP_WIDTH[props.$locale]} * 6)) {
    .search-filters-body > :nth-child(9):not(:last-child) {
      display: initial;
    }
  }

  @media all and (min-width: calc(${cssBreakpoints.mdUp} + ${(props) =>
      SEARCH_FILTERS_DROPDOWN_CHIP_WIDTH[props.$locale]} * 7)) {
    .search-filters-body > :nth-child(10):not(:last-child) {
      display: initial;
    }
  }

  /* Overflow menu visibility tracking */

  /* SimilarToFilter should never appear in overflow menu */
  & > div > :last-child menu [data-facet-type='synonymId'] {
    display: none;
  }

  /* First 3 always hidden */
  & > div > :last-child menu details:nth-of-type(-n + 3) {
    display: none;
  }

  @media all and (min-width: calc(${cssBreakpoints.mdUp} + ${(props) =>
      SEARCH_FILTERS_DROPDOWN_CHIP_WIDTH[props.$locale]})) {
    & > div > :last-child menu details:nth-of-type(4) {
      display: none;
    }
  }

  @media all and (min-width: calc(${cssBreakpoints.mdUp} + ${(props) =>
      SEARCH_FILTERS_DROPDOWN_CHIP_WIDTH[props.$locale]} * 2)) {
    & > div > :last-child menu details:nth-of-type(5) {
      display: none;
    }
  }

  @media all and (min-width: calc(${cssBreakpoints.mdUp} + ${(props) =>
      SEARCH_FILTERS_DROPDOWN_CHIP_WIDTH[props.$locale]} *
    3)) {
    & > div > :last-child menu details:nth-of-type(6) {
      display: none;
    }
  }

  @media all and (min-width: calc(${cssBreakpoints.mdUp} + ${(props) =>
      SEARCH_FILTERS_DROPDOWN_CHIP_WIDTH[props.$locale]} *
    4)) {
    & > div > :last-child menu details:nth-of-type(7) {
      display: none;
    }
  }

  @media all and (min-width: calc(${cssBreakpoints.mdUp} + ${(props) =>
      SEARCH_FILTERS_DROPDOWN_CHIP_WIDTH[props.$locale]} *
    5)) {
    & > div > :last-child menu details:nth-of-type(8) {
      display: none;
    }
  }

  @media all and (min-width: calc(${cssBreakpoints.mdUp} + ${(props) =>
      SEARCH_FILTERS_DROPDOWN_CHIP_WIDTH[props.$locale]} *
    6)) {
    & > div > :last-child menu details:nth-of-type(9) {
      display: none;
    }
  }

  @media all and (min-width: calc(${cssBreakpoints.mdUp} + ${(props) =>
      SEARCH_FILTERS_DROPDOWN_CHIP_WIDTH[props.$locale]} * 7)) {
    & > div > :last-child menu details:nth-of-type(10) {
      display: none;
    }
  }
`;

export const SearchFiltersBody = styled.div`
  display: flex;
  gap: ${spacing[24]};
`;
